import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MeasuringPoint} from 'src/app/model/Sensor';
import {DaysToHours} from '../daysToHours.enum';
import {formatDate} from '@angular/common';

@Component({
  selector: 'met-point-diagram',
  templateUrl: './point-diagram.component.html',
  styleUrls: ['./point-diagram.component.scss'],
})
export class PointDiagramComponent {
  @Input()
  mappedStations!: Map<DaysToHours, Array<{sensorType: string; inactive: boolean; measuringPoints: MeasuringPoint[]}>>;

  @Input()
  selectedTimeInterval!: DaysToHours;

  @Output()
  switchTimeInterval = new EventEmitter<DaysToHours>();

  timeIntervalChange(interval: DaysToHours) {
    this.switchTimeInterval.emit(interval);
  }

  convertDate(date: string | number | Date): string {
    const d = this.toUtcDate(date);
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
      timeZone: 'Europe/Berlin', timeZoneName: 'short'
    }).format(d);
  }

  convertDateDayAndMonth(date: string | number | Date): string {
    return formatDate(this.toUtcDate(date), 'dd.MM.', 'de', 'Europe/Berlin');
  }

  private toUtcDate(d: string | number | Date): Date {
    if (d instanceof Date) return d;
    if (typeof d === 'number') return new Date(d);
    const s = String(d).replace(' ', 'T');
    if (/^\d+$/.test(s)) return new Date(Number(s));
    return /[zZ]|[+\-]\d{2}:\d{2}$/.test(s) ? new Date(s) : new Date(s + 'Z');
  }

  isStartOfNewDay(current: MeasuringPoint, previous?: MeasuringPoint): boolean {
    if (!previous) return false;

    const currentDate = this.toUtcDate(current.timeStamp);
    const prevDate = this.toUtcDate(previous.timeStamp);

    return currentDate.getDate() !== prevDate.getDate() ||
      currentDate.getMonth() !== prevDate.getMonth() ||
      currentDate.getFullYear() !== prevDate.getFullYear();
  }

}
